import { withStyles, Avatar, withTheme } from '@material-ui/core';
import { formatAddress } from '../../../../Dispatch/utils/utils';
import StyledToolTip from '../../../../../common/StyledToolTip';
import { useNavigate } from 'react-router-dom';
import { compose } from 'recompose';
import { isUnattendedStop } from '../../../../utils';
import UnattendedDelivery from '../../../../Common/UnattendedDelivery';
import { STOP_TYPE } from '../../constants';
import CustomerMergeIndicator from '../../../../../common/CustomerMergeIndicator';

const styles = (theme) => ({
  container: {
    borderBottom: `1px solid ${theme.AppBGColor}`,
    width: '100%',
    padding: '10px 0px',
    display: 'flex',
    alignItems: 'center'
  },
  consigneeName: {
    color: theme.HeaderSelectedText,
    fontSize: theme.textFontSize,
    fontWeight: 600
  },
  headerText: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  stop: {
    color: theme.HeaderSelectedText,
    backgroundColor: theme.ComponentHeader,
    border: `1px solid ${theme.HeaderSelectedText}`,
    width: 26,
    height: 26,
    fontSize: theme.headerTextFontSize,
    marginRight: 14
  },
  pickupStop: {
    borderRadius: '3px'
  },
  statusContainer: {
    color: theme.infoTextColor,
    fontSize: theme.textFontSize,
    fontWeight: 500,
    backgroundColor: theme.infoBGColor,
    padding: '8px 12px',
    borderRadius: 19,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex'
  },
  nameContainer: {
    minWidth: 0
  },
  nameContainerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  showUnderLineText: {
    textDecorationLine: 'underline',
    cursor: 'pointer'
  }
});

const RouteKPI = ({ classes, theme, stopData }) => {
  const navigate = useNavigate();
  const openEditCustomer = () => {
    if (stopData.customerCode) {
      navigate(`?customerCode=${stopData.customerCode}`, {
        state: {
          closeOnRefresh: true
        }
      });
    }
  };
  const fullAddress = formatAddress({
    address: stopData.consigneeDetails?.address,
    city: stopData.consigneeDetails?.city,
    state: stopData.consigneeDetails?.state,
    zip: stopData.consigneeDetails?.zip
  });
  const showCustomerLink =
    stopData.customerCode &&
    !stopData.isMiscCustomer &&
    stopData.stopType === STOP_TYPE.Delivery; // added stopType condition now will remove this once shipper story ready

  const unattendedStop = isUnattendedStop(stopData);
  return (
    <div className={classes.container}>
      <Avatar
        className={`${classes.stop} ${
          stopData.stopType === STOP_TYPE.Pickup ? classes.pickupStop : ''
        }`}>
        {stopData.routeMaxUIStopSequence}
      </Avatar>
      <div className={classes.nameContainer}>
        <div className={classes.nameContainerRow}>
          <div
            className={`${classes.consigneeName} ${
              showCustomerLink ? classes.showUnderLineText : ''
            }`}
            onClick={showCustomerLink ? openEditCustomer : null}>
            {stopData.consigneeDetails?.displayCustomerName || ''}
            <CustomerMergeIndicator
              displayCustomerName={stopData.consigneeDetails?.displayCustomerName}
              customerName={stopData.consigneeDetails?.name}
            />
          </div>
          {unattendedStop && (
            <span>
              <UnattendedDelivery color={theme.palette.primary.main} />
            </span>
          )}
        </div>
        <StyledToolTip title={fullAddress}>
          <div className={classes.headerText}>{fullAddress}</div>
        </StyledToolTip>
      </div>
    </div>
  );
};

export default compose(withStyles(styles), withTheme())(RouteKPI);
